import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef, useRef } from 'react';
import { useLinearPrimaryTicks } from 'react-d3-utils';
const VerticalAxis = forwardRef((props, ref) => {
    const { x, y, height, width, showGrid, ticks } = props;
    return (_jsxs("g", { ref: ref, transform: `translate(${x}, ${y})`, children: [_jsx("line", { y2: height, x1: 15, x2: 15, stroke: "black" }), ticks.map(({ label, position }, index) => (
            // eslint-disable-next-line react/no-array-index-key
            _jsxs("g", { children: [showGrid && width && (_jsx("line", { y1: position, y2: position, x1: 15, x2: width - x, stroke: "lightgray" })), _jsx("line", { y1: position, y2: position, x1: 15, x2: 10, stroke: "black" }), _jsx("text", { y: position, dominantBaseline: "middle", textAnchor: "end", fill: "black", children: label })] }, index + label + position)))] }));
});
export function LinearVerticalAxis(props) {
    const { scale, ...other } = props;
    const ref = useRef(null);
    const ticks = useLinearPrimaryTicks(scale, 'vertical', ref);
    return _jsx(VerticalAxis, { ...other, ticks: ticks, ref: ref });
}
